import { Typography } from "@mui/material"
import IconBox from "../../IconBox"
import { OperationDetailsProps } from "../props"
import {
  AccordionBody,
  AccordionHeader,
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailsContainerTextOverflow,
  DetailValue,
  ScrollContainer,
  StatusChecked,
  StyledAccordion,
  StyledDivider,
  Subtext,
  TopContainer,
} from "../styled"
import UIIcon from "../../UIIcon"
import { formatAmount, formatPhoneNumber } from "../../../utils/formatters"
import { RUBLE } from "../../../utils/constants"
import { getOperationStatusDetails } from "../../../utils/operation"
import { getTimezone } from "../../../utils/datetime"

const OutcomeTransferHistoryDetails = ({
  operation,
  isRefund,
}: OperationDetailsProps) => {
  const toCustomerPhone = operation.fields.find(
    (f) => f.name === "ToCustomerPhone",
  )
  const description = operation.fields.find((f) => f.name === "Description")

  const statusDetails = getOperationStatusDetails(operation)
  const iconName = isRefund ? "incomeGrey" : "outcomeYellow"

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg" color="yellow">
            <UIIcon
              iconName={
                statusDetails.isSuccesseful ? iconName : statusDetails.icon
              }
              size={80}
            />
          </IconBox>
          <Amount>
            {formatAmount(operation.amount)} {RUBLE}
          </Amount>
          <Subtext>
            {isRefund ? "Возврат исходящего перевода" : "Исходящий перевод"}
          </Subtext>
        </TopContainer>
        <StyledDivider />
        <StyledAccordion>
          <AccordionHeader
            expandIcon={<UIIcon iconName="arrowDown" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h4">Подробнее об операции</Typography>
          </AccordionHeader>
          <AccordionBody>
            <DetailsContainer sx={DetailsContainerTextOverflow}>
              <DetailContainer>
                <DetailLabel>Статус операции</DetailLabel>
                <DetailValue>
                  <StatusChecked statusColor={statusDetails.color}>
                    {statusDetails.message}
                  </StatusChecked>
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер операции в РНКО «Единая Касса»</DetailLabel>
                <DetailValue>{operation.contextOperationId}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер телефона получателя</DetailLabel>
                <DetailValue>
                  {toCustomerPhone
                    ? formatPhoneNumber(toCustomerPhone?.value)
                    : ""}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Описание</DetailLabel>
                <DetailValue>{description?.value}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Сумма перевода</DetailLabel>
                <DetailValue>
                  {formatAmount(operation.amount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Комиссия</DetailLabel>
                <DetailValue>
                  {formatAmount(operation.bottomCommissionAmount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Дата и время операции</DetailLabel>
                <DetailValue>{getTimezone(operation.updatedOn)}</DetailValue>
              </DetailContainer>
            </DetailsContainer>
          </AccordionBody>
        </StyledAccordion>
      </ScrollContainer>
    </ContentContainer>
  )
}

export default OutcomeTransferHistoryDetails
